import { LoadingSceneBackdrop } from "~mangomap-ui/components/loading-scene/loading-scene-backdrop";

import { useLoadingLogoUrl } from "~auth/hooks/use-loading-logo-url";

export const AuthLoadingBackdrop = () => {
	const { fallbackLogoUrl, logoUrl } = useLoadingLogoUrl();

	return (
		<LoadingSceneBackdrop
			fallbackLogoUrl={fallbackLogoUrl}
			logoUrl={logoUrl}
		/>
	);
};
